// extracted by mini-css-extract-plugin
module.exports = {"infoHeader":"InfoHeader_infoHeader__1f-QV","title":"InfoHeader_title__3KGQi","details":"InfoHeader_details__1dZ9r"};